import type {
  ExpenseBreakdownDTO,
  ExpenseBreakdownItemDto,
} from "../models/expenseBreakdownDto";
import type {
  ExpenseBreakdownEntity,
  ExpenseBreakdownItemEntity,
  ExpenseBreakdownTimeframe,
  ExpenseBreakdownType,
  ExpenseBreakdownUnavailableReason,
} from "../../domain/entities/ExpenseBreakdownEntity";

function mapItem(dto: ExpenseBreakdownItemDto): ExpenseBreakdownItemEntity {
  return {
    name: typeof dto.name === "string" ? dto.name : "",
    amount: Number(dto.amount) || 0,
    percent: Number(dto.percent) || 0,
  };
}

function mapUnavailableReason(
  v: unknown,
): ExpenseBreakdownUnavailableReason | null | undefined {
  if (v === undefined) return undefined;
  if (v === null) return null;
  if (v === "no_closed_books" || v === "no_closed_months_in_fy") {
    return v;
  }
  return null;
}

export function expenseBreakdownDtoToEntity(
  dto: ExpenseBreakdownDTO,
): ExpenseBreakdownEntity {
  const breakdownType: ExpenseBreakdownType =
    dto.breakdownType === "category" || dto.breakdownType === "vendor"
      ? dto.breakdownType
      : "vendor";
  const timeframe: ExpenseBreakdownTimeframe =
    dto.timeframe === "last_month" || dto.timeframe === "ytd"
      ? dto.timeframe
      : "ytd";
  const defaultPeriodLabel =
    timeframe === "ytd" ? "FY Expenses (Closed)" : "Last Month";

  return {
    breakdownType,
    timeframe,
    periodLabel:
      typeof dto.periodLabel === "string"
        ? dto.periodLabel
        : defaultPeriodLabel,
    dateRangeStart:
      dto.dateRangeStart === undefined
        ? undefined
        : dto.dateRangeStart === null
          ? null
          : typeof dto.dateRangeStart === "string"
            ? dto.dateRangeStart
            : null,
    dateRangeEnd:
      dto.dateRangeEnd === undefined
        ? undefined
        : dto.dateRangeEnd === null
          ? null
          : typeof dto.dateRangeEnd === "string"
            ? dto.dateRangeEnd
            : null,
    breakdownUnavailableReason: mapUnavailableReason(
      dto.breakdownUnavailableReason,
    ),
    totalExpense: Number(dto.totalExpense) || 0,
    summary:
      dto.summary && typeof dto.summary === "object" && dto.summary !== null
        ? {
            totalExpense: Number(dto.summary.totalExpense) || 0,
            billsNetExpense: Number(dto.summary.billsNetExpense) || 0,
            billsExpense: Number(dto.summary.billsExpense) || 0,
            creditDebitNotes: Number(dto.summary.creditDebitNotes) || 0,
            journalsExpense: Number(dto.summary.journalsExpense) || 0,
            invoicesExpenseGl: Number(dto.summary.invoicesExpenseGl) || 0,
            bankVendorExpense: Number(dto.summary.bankVendorExpense) || 0,
            bankCharges: Number(dto.summary.bankCharges) || 0,
            bankForexExpenseAdj: Number(dto.summary.bankForexExpenseAdj) || 0,
          }
        : undefined,
    items: Array.isArray(dto.items) ? dto.items.map(mapItem) : [],
  };
}
